import { ImageParams } from 'components/Common/ResponsiveImage'
import ImageGallery from 'components/Luxkit/Carousel/ImageGallery'
import ProductTypeLabel from 'components/Luxkit/Label/ProductTypeLabel'
import { isBedbank } from 'lib/offer/offerTypes'
import React from 'react'

interface Props {
  imageProps?: ImageParams;
  className?: string;
  offer: App.Offer | App.BedbankOffer;
  open?: boolean;
  onClose?: () => void;
  room: App.PackageRoomType | App.BedbankPackage;
  topRight?: React.ReactNode;
}

function OfferPageRoomGallery(props: Props) {
  const {
    offer,
    className,
    imageProps,
    room,
    topRight,
  } = props

  return <ImageGallery
    className={className}
    images={room.images}
    imageParams={imageProps}
    topLeft={!isBedbank(offer) && <ProductTypeLabel productType={offer.productType} />}
    size="small"
    showImageTitles={false}
    topRight={topRight}
  />
}

export default OfferPageRoomGallery
